import React, { useContext } from 'react';
import { useQueryClient } from 'react-query';

import BaseModal from '@/components/Modals/BaseModal';
import { EditProfileContext } from '@/contexts/EditProfileProvider';
import { useCancelSubscription } from '@/Utils/stripeHooks/useCancelSubscription';
import { updatedSubscriptionAlertMessageOptions } from '@/Utils/useAlertMessage';

type Props = {
  handleOpenModal: (type: null) => void;
};

const CancelSubscriptionModal: React.FC<Props> = ({ handleOpenModal }) => {
  const { showAlert } = useContext(EditProfileContext);
  const queryClient = useQueryClient();

  const { mutateAsync: cancelSubscription, isLoading } = useCancelSubscription({
    onSuccess: () => {
      queryClient.invalidateQueries(['currentUser']);
      handleOpenModal(null);
      showAlert(updatedSubscriptionAlertMessageOptions);
    },
  });

  const handleClick = async () => {
    await cancelSubscription();
  };

  return (
    <BaseModal
      icon='/icons/warning-full.svg'
      title='Cancel Subscription'
      text={
        <div className='flex flex-col gap-10'>
          <span>
            If you cancel your subscription now, you will retain access to its
            benefits until the end of your current billing cycle.
          </span>
          <span>
            If you have funds remaining on your balance, a refund will be
            processed within 3-5 business days.
          </span>
          <span>
            For any questions or concerns, feel free to contact our Customer
            Support at{' '}
            <a href='mailto:info@evo-lux.com' className='text-blue-500'>
              info@evo-lux.com
            </a>
          </span>
        </div>
      }
      cancelButton
      primaryButtonText='Cancel Subscription'
      handlePrimaryButton={handleClick}
      handleCancel={() => handleOpenModal(null)}
      isLoading={isLoading}
    />
  );
};
export default CancelSubscriptionModal;
